export const DEFAULT_THEME = {
  primary_color: '#6739E0',
  sidebar_color: '#3A2180',
};

export const THEME_PRESETS = [
  { key: 'lmcid', name: "L'mcid Violet", primary_color: '#6739E0', sidebar_color: '#3A2180' },
  { key: 'ocean', name: 'Ocean Blue', primary_color: '#0284C7', sidebar_color: '#0C4A6E' },
  { key: 'emerald', name: 'Emerald Learning', primary_color: '#059669', sidebar_color: '#064E3B' },
  { key: 'royal', name: 'Royal Indigo', primary_color: '#4F46E5', sidebar_color: '#1E1B4B' },
  { key: 'coral', name: 'Warm Coral', primary_color: '#E85946', sidebar_color: '#7F1D1D' },
  { key: 'teal', name: 'Modern Teal', primary_color: '#0D9488', sidebar_color: '#134E4A' },
];

const HEX_COLOR = /^#[0-9a-f]{6}$/i;
const DEFAULT_PRIMARY_SHADES = {
  50: [245, 244, 255],
  100: [236, 232, 254],
  200: [217, 209, 253],
  300: [188, 174, 250],
  400: [154, 128, 245],
  500: [125, 90, 239],
  600: [103, 57, 224],
  700: [85, 43, 196],
  800: [70, 37, 158],
  900: [58, 33, 128],
};

export function normalizeHex(value, fallback) {
  const color = String(value || '').trim();
  return HEX_COLOR.test(color) ? color.toUpperCase() : fallback;
}

function hexToRgb(hex) {
  const value = normalizeHex(hex, '#000000').slice(1);
  return [0, 2, 4].map((index) => parseInt(value.slice(index, index + 2), 16));
}

function mix(rgb, target, amount) {
  return rgb.map((channel, index) => Math.round(channel + (target[index] - channel) * amount));
}

function cssRgb(rgb) {
  return rgb.join(' ');
}

export function applyBrandTheme(theme = {}) {
  if (typeof document === 'undefined') return;
  const primary = normalizeHex(theme.primary_color, DEFAULT_THEME.primary_color);
  const sidebar = normalizeHex(theme.sidebar_color, DEFAULT_THEME.sidebar_color);
  const base = hexToRgb(primary);
  const white = [255, 255, 255];
  const black = [0, 0, 0];
  const generatedShades = {
    50: mix(base, white, 0.94),
    100: mix(base, white, 0.87),
    200: mix(base, white, 0.74),
    300: mix(base, white, 0.54),
    400: mix(base, white, 0.29),
    500: mix(base, white, 0.12),
    600: base,
    700: mix(base, black, 0.15),
    800: mix(base, black, 0.30),
    900: mix(base, black, 0.45),
  };
  const shades = primary === DEFAULT_THEME.primary_color ? DEFAULT_PRIMARY_SHADES : generatedShades;
  const root = document.documentElement;
  Object.entries(shades).forEach(([shade, rgb]) => {
    root.style.setProperty(`--color-primary-${shade}`, cssRgb(rgb));
  });
  root.style.setProperty('--color-sidebar', cssRgb(hexToRgb(sidebar)));
}
